// extracted by mini-css-extract-plugin
module.exports = {"genericButton":"Buttons_genericButton__Wlc2B","primaryButton":"Buttons_primaryButton___kVv1","secondaryButton":"Buttons_secondaryButton__gAn8A","arrow":"Buttons_arrow__TDAUu"};